import React from "react";

/**
 * Input réutilisable
 * Props :
 *  - label
 *  - type
 *  - value
 *  - onChange
 *  - placeholder
 *  - className
 *  - ...rest
 */
const Input = ({
  label = "",
  type = "text",
  value,
  onChange,
  placeholder = "",
  className = "",
  ...rest
}) => {
  return (
    <div className={`md-input-wrapper ${className}`}>
      {label ? <label className="md-input-label">{label}</label> : null}

      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="md-input-field"
        {...rest}
      />

      <style>{`
        .md-input-wrapper {
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
        }

        .md-input-label {
          font-family: var(--font-sans);
          font-size: 0.82rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: rgba(0, 0, 0, 0.72);
        }

        .md-input-field {
          width: 100%;
          min-height: 52px;
          padding: 14px 16px;
          border-radius: 12px;
          border: 1px solid rgba(212, 175, 55, 0.35);
          background: rgba(255, 255, 255, 0.98);
          color: var(--dark);
          font-family: var(--font-sans);
          font-size: 1rem;
          line-height: 1.2;
          box-sizing: border-box;
          outline: none;
          transition: border-color 0.2s ease, box-shadow 0.2s ease,
            background 0.2s ease;
        }

        .md-input-field::placeholder {
          color: rgba(0, 0, 0, 0.35);
        }

        .md-input-field:focus {
          border-color: var(--gold-dark);
          box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.14);
          background: #fff;
        }

        .md-input-field:disabled {
          opacity: 0.65;
          cursor: not-allowed;
          background: rgba(245, 245, 245, 0.9);
        }
      `}</style>
    </div>
  );
};

export default Input;
